<template>
    <div class="vh-100 vw-100 d-flex flex-column">
      <DefaultHeader :noMargin="true"/>
      <GeofencingMap />
    </div>
  </template>
  
  <script>
  import DefaultHeader from '@/components/DefaultHeader.vue'
  import GeofencingMap from './Sections/GeofencingMap.vue'
  
  export default {
      components: {
          DefaultHeader,
          GeofencingMap
      },
      computed: {
          currentUser() {
              return this.$store.state.auth.user
          }
      },
      mounted() {
          if (!this.currentUser) {
              this.$router.push('/')
          }
      }
  }
  </script>